import { StyleSheet } from "react-native-unistyles";

const stylesheet = StyleSheet.create(
  ({ spacing, colors, border }, { insets }) => ({
    container: {
      paddingVertical: {
        xs: spacing(18) + insets.top,
        sm: spacing(42) + insets.top,
      },
      paddingHorizontal: {
        xs: spacing(4),
        sm: spacing(6),
      },
    },
    form: {
      gap: spacing(2),
      borderRadius: border.radius.md,
      width: "100%",
      marginHorizontal: "auto",
      paddingVertical: spacing(12),
      paddingHorizontal: {
        xs: spacing(2),
        lg: spacing(8),
      },
      maxWidth: {
        lg: spacing(144),
      },
      backgroundColor: {
        lg: colors.backgroundFloat,
      },
    },
    logo: {
      height: spacing(8),
      marginBottom: spacing(4),
    },
    title: {
      marginTop: spacing(4),
      marginBottom: spacing(8),
    },
    field: {
      width: "100%",
      gap: spacing(2),
      marginBottom: spacing(4),
    },
    button: {
      marginTop: spacing(6),
    },
    link: {
      marginTop: spacing(4),
      alignSelf: "center",
    },
  }),
);

export default stylesheet;
